import * as Helper from "../../_Helper";
import * as Const from "../../_Const";

const controller = "/infopanels/terminal/";

function getUrl(uid) {
  //api/infopanels/terminal/{uid}/data
  return `${controller}${uid?.toString()}/data`;
}

function getUrlGrouped(uid) {
  //api/infopanels/terminal/{uid}/datagrouped
  return `${controller}${uid?.toString()}/datagrouped`;
}

function getPutNotificationUrl(uid, notificationId) {
  //api/infopanels/terminal/{uid}/receivenotification/{logInfoPanelStateChangeId}
  return `${controller}${uid?.toString()}/receivenotification/${notificationId?.toString()}`;
}

export function getData(http, uid) {
  //console.log(getUrl(uid));
  return http.get(getUrl(uid), Helper.getAuthConfig(uid));
}

export function getDataGrouped(http, uid) {
  return http.get(getUrlGrouped(uid), Helper.getAuthConfig(uid));
}

export function putNotification(http, uid, notificationId) {
  return http.put(getPutNotificationUrl(uid, notificationId), null, Helper.getAuthConfig(uid));
}
